const localAppId = 'ee20ed10-0427-4a6e-a9fa-df821d7e279f';
const devAppId = '2bc93447-c725-49a1-accf-9d0c49d3a3c6';
const qaAppId = '059ede3d-477e-4d33-8149-1bce22231998';
const prodAppId = 'b695b41b-2377-4a0a-8024-874445c15434';
export default function () {
  try {
    let appId = localAppId;
    if (document.location.host.includes('usafacts.org')) {
      switch (document.location.host.split('.')[0]) {
        case undefined:
        case 'usafacts':
          appId = prodAppId;
          break;
        case 'qa':
          appId = qaAppId;
          break;
        case 'dev':
          appId = devAppId;
          break;
        default:
          break;
      }
    }
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/OneSignalSDKWorker.js', {
        scope: '/onesignal'
      }).then(() => {
        console.log('Initializing OneSignal');
        // eslint-disable-next-line no-undef
        OneSignal.push(() => {
          // eslint-disable-next-line no-undef
          OneSignal.init({
            appId,
            welcomeNotification: {
              disable: false
            },
            promptOptions: {
              showCredit: false
            }
          });
        });
      }).catch(e => {
        console.warn('OneSignal Service Worker Registration Failed', e);
      });
    }
  } catch (e) {
    console.error('Unable to start OneSignal', e);
  }
}